import { getActiveFlashSaleRotation } from './flashSaleRotation';
import type { YearEndFlashSaleRotation } from '../../constants/campaign/yearEndFlashSale';
import {
  YEAR_END_FLASH_SALE_ROTATIONS,
  YEAR_END_FLASH_SALE_TIMEZONE,
} from '../../constants/campaign/yearEndFlashSale';

/**
 * Gets the active Year End Flash Sale rotation based on current time in SGT
 *
 * @param pattern Optional custom date-fns parse pattern. Defaults to 'yyyy-MM-dd HH:mm:ss'
 * @returns The active rotation if found, null otherwise
 */
export const getActiveYearEndFlashSaleRotation = (
  pattern = 'yyyy-MM-dd HH:mm:ss',
): YearEndFlashSaleRotation | null => {
  return getActiveFlashSaleRotation(YEAR_END_FLASH_SALE_ROTATIONS, YEAR_END_FLASH_SALE_TIMEZONE, pattern);
};
